import { useRef, useState } from "react"

import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { Link } from "@inertiajs/react"

const categories = [
    {
        label: "Handguns",
        image: "./images/handgun.webp",
        href: "/categories/handguns",
    },
    {
        label: "Rifles",
        image: "./images/rifle.webp",
        href: "/categories/rifles",
    },
    {
        label: "Shotguns",
        image: "./images/shotguns.webp",
        href: "/categories/shotguns",
    },
    {
        label: "Accessories",
        image: "./images/accessories.webp",
        href: "/categories/parts-and-accessories",
    },
]

const CategoryCard = ({
    category,
    labelClassName = "bottom-5",
    onClick,
    className = "",
}) => (
    <Link
        href={category.href}
        onClick={onClick}
        className={`relative block cursor-pointer group ${className}`}
    >
        <img
            src={category.image}
            alt={category.label}
            className="w-full h-auto"
            width={411}
            height={263}
            loading="lazy"
        />
        <div
            className={`absolute inset-x-0 flex justify-center text-lg font-bold text-white ${labelClassName}`}
        >
            {category.label}
        </div>
    </Link>
)

export const ShopCategory = () => {
    const [currentSlide, setCurrentSlide] = useState(0)
    const [slider, setSlider] = useState(null)
    const isDragging = useRef(false)

    const handleCardClick = (event) => {
        if (isDragging.current) {
            event.preventDefault()
        }
    }

    const goToNextSlide = () => {
        if (slider) {
            slider.slickNext()
        }
    }

    const goToPrevSlide = () => {
        if (slider) {
            slider.slickPrev()
        }
    }

    const goToSlide = (index) => {
        if (slider) {
            slider.slickGoTo(index)
        }
        setCurrentSlide(index)
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipe: true,
        arrows: false,
        beforeChange: () => {
            isDragging.current = true
        },
        afterChange: (index) => {
            isDragging.current = false
            setCurrentSlide(index)
        },
        ref: (slider) => setSlider(slider),
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    }

    return (
        <div className="flex justify-center w-full">
            <div className="container flex flex-col items-center w-full gap-8 p-4 mt-8 md:mt-16">
                <div className="flex flex-col items-center text-center">
                    <h2 className="text-2xl font-bold text-black lg:text-3xl">
                        Shop by Gun Category
                    </h2>
                    <p className="mt-2 text-sm font-normal text-black lg:text-xl">
                        Find exactly what you're looking for
                    </p>
                </div>

                <div className="hidden w-full gap-4 lg:grid lg:grid-cols-4">
                    {categories.map((category) => (
                        <CategoryCard
                            key={category.label}
                            category={category}
                        />
                    ))}
                </div>

                <div className="relative w-full lg:hidden">
                    <Slider {...settings} className="block w-full mx-auto">
                        {categories.map((category) => (
                            <CategoryCard
                                key={category.label}
                                category={category}
                                labelClassName="bottom-12"
                                onClick={handleCardClick}
                                className="px-2 max-w-[85%] mx-auto md:max-w-none"
                            />
                        ))}
                    </Slider>

                    <div className="absolute inset-y-0 flex items-center justify-between w-full px-2 pointer-events-none">
                        <button
                            className="text-white pointer-events-auto prev-button"
                            onClick={goToPrevSlide}
                            aria-label="Previous category"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg "
                                width="30"
                                height="30"
                                fill="currentColor"
                                className="bi bi-chevron-left"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                                />
                            </svg>
                        </button>

                        <button
                            className="text-white pointer-events-auto next-button"
                            onClick={goToNextSlide}
                            aria-label="Next category"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                fill="currentColor"
                                className="bi bi-chevron-right"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    fillRule="evenodd"
                                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                                />
                            </svg>
                        </button>
                    </div>

                    <div className="absolute flex items-center justify-center w-full bottom-4">
                        {categories.map((_, dotIndex) => (
                            <div
                                key={dotIndex}
                                className={`h-2 rounded-full mx-1 cursor-pointer ${
                                    dotIndex === currentSlide
                                        ? "w-8 bg-[#C9A876]"
                                        : "w-2 bg-[#6B7280]"
                                }`}
                                onClick={() => goToSlide(dotIndex)}
                            ></div>
                        ))}
                    </div>
                </div>
                <Link className="mx-auto" href={route("categories.index")}>
                    <div className="sm:ms-5 lg:ms-0 flex h-[48px] w-[225px] text-neutral-50 rounded-md transition-colors bg-[#800020] hover:bg-maroon-light items-center justify-center">
                        View More
                    </div>
                </Link>
            </div>
        </div>
    )
}
